import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import { Role } from '@/modules/auth/types';
import router from './router';

menuRegistry.registerMenu([
    {
        key: 'SystemWide',
        name: 'System Wide',
        icon: 'fas fa-server'
    },
    {
        key: 'General',
        name: 'General',
        icon: 'fas fa-cogs',
        roles: [Role.ADMIN]
    },
    {
        key: 'Payment',
        name: 'Payment',
        icon: 'fas fa-dollar-sign'
    },
    {
        key: 'ThirdParty',
        name: 'Third Party',
        icon: 'fas fa-plug'
    },
    {
        key: 'Multiplayer',
        name: 'Multiplayer',
        icon: 'fas fa-users'
    },
    {
        key: 'Puzzle',
        name: 'Puzzle',
        icon: 'fas fa-puzzle-piece'
    }
]);

export default registerRouteForModule(router);
